import { ReactComponent as AssumptionsIcon } from "../assets/images/icons/Menu/assumptions.svg";
import { ReactComponent as SubscriberIcon } from "../assets/images/icons/Menu/subscriber.svg";
import { ReactComponent as RevenueIcon } from "../assets/images/icons/Menu/revenue.svg";
import { ReactComponent as CostIcon } from "../assets/images/icons/Menu/cost.svg";
import { ReactComponent as HiringPlanIcon } from "../assets/images/icons/Menu/hriringPlan.svg";
import { ReactComponent as ProfitLossIcon } from "../assets/images/icons/Menu/profitLoss.svg";
import { ReactComponent as FreeCashFlowIcon } from "../assets/images/icons/Menu/freeCashFlow.svg";
import { ReactComponent as CalculatorIcon } from "../assets/images/icons/Menu/calculator.svg";
import { ReactComponent as SettingsIcon } from "../assets/images/icons/Menu/settings.svg";
import {
  IconAnalyze,
  IconDashboard,
  IconCalculator,
  IconSettings,
  IconNotes,
} from "@tabler/icons";
import { defaultPath, mainPages, path } from "routes/constant";
import { SaaSCoType, GeneralCoType } from "../constants/companyTypes";

const icons = {
  IconAnalyze,
  IconDashboard,
  IconCalculator,
  IconSettings,
  IconNotes,
};

export const menuItems = [
  {
    id: mainPages.FINANCIAL_FORECAST,
    titles: {
      [SaaSCoType]: "Financial Forecast",
      [GeneralCoType]: "Financial Forecast",
    },
    icon: icons.IconAnalyze,
    url: defaultPath.FINANCIAL_FORECAST,
    companyTypes: [SaaSCoType, GeneralCoType],
    children: [
      {
        id: "financial-forecast",
        titles: {
          [SaaSCoType]: "Company Details",
          [GeneralCoType]: "Company Details",
        },
        type: "item",
        url: path.FINANCIAL_FORECAST_COMPANY_DETAILS,
        icon: <AssumptionsIcon />,
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "financial-forecast",
        titles: {
          [SaaSCoType]: "Assumptions",
          [GeneralCoType]: "Assumptions",
        },
        type: "item",
        url: path.FINANCIAL_FORECAST_ASSUMPTIONS,
        icon: <AssumptionsIcon />,
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "financial-forecast",
        titles: {
          [SaaSCoType]: "Subscriber Acquisitions",
          [GeneralCoType]: "Subscriber Acquisitions",
        },
        type: "item",
        url: path.FINANCIAL_FORECAST_SUBSCRIBER_CQUISITIONS,
        icon: <SubscriberIcon />,
        companyTypes: [SaaSCoType],
      },
      {
        id: "financial-forecast",
        titles: {
          [SaaSCoType]: "Revenue",
          [GeneralCoType]: "Revenue and Cost of Sales",
        },
        type: "item",
        url: path.FINANCIAL_FORECAST_REVENUE,
        icon: <RevenueIcon />,
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "financial-forecast",
        titles: {
          [SaaSCoType]: "Cost And Expenses",
          [GeneralCoType]: "Operating Expenses",
        },
        type: "item",
        url: path.FINANCIAL_FORECAST_COST_AND_EXPENSES,
        icon: <CostIcon />,
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "financial-forecast",
        titles: {
          [SaaSCoType]: "Hiring Plan",
          [GeneralCoType]: "Hiring Plan",
        },
        type: "item",
        url: path.FINANCIAL_FORECAST_HIRING_PLAN,
        icon: <HiringPlanIcon />,
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "financial-forecast",
        titles: {
          [SaaSCoType]: "Profit & Loss",
          [GeneralCoType]: "Profit & Loss",
        },
        type: "item",
        url: path.FINANCIAL_FORECAST_PROFIT_LOSS,
        icon: <ProfitLossIcon />,
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "financial-forecast",
        titles: {
          [SaaSCoType]: "Free Cash Flow",
          [GeneralCoType]: "Free Cash Flow",
        },
        type: "item",
        url: path.FINANCIAL_FORECAST_FREECASH_FLOW,
        icon: <FreeCashFlowIcon />,
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: mainPages.CUSTOMIZE,
        titles: {
          [SaaSCoType]: "Customize",
          [GeneralCoType]: "Customize",
        },
        type: "item",
        url: path.CUSTOMIZATION,
        icon: <SettingsIcon />,
        companyTypes: [SaaSCoType, GeneralCoType],
      },
    ],
  },
  {
    id: mainPages.CALCULATORS,
    titles: {
      [SaaSCoType]: "Calculators",
      [GeneralCoType]: "Calculators",
    },
    caption: "Plansas Calculators",
    icon: icons.IconCalculator,
    url: defaultPath.CALCULATORS,
    companyTypes: [SaaSCoType, GeneralCoType],
    children: [
      {
        id: "calculators",
        titles: {
          [SaaSCoType]: "SaaS Subscription Fee Calculator",
          [GeneralCoType]: "General Subscription Fee Calculator",
        },
        type: "item",
        url: "/calculators/saas-subscription-fee",
        icon: <CalculatorIcon />,
        companyTypes: [SaaSCoType, GeneralCoType],
      },
      {
        id: "calculators",
        titles: {
          [SaaSCoType]: "Emergency Fund Calculator",
          [GeneralCoType]: "Emergency Fund Calculator",
        },
        type: "item",
        url: "/calculators/emergency-fund",
        icon: <CalculatorIcon />,
        companyTypes: [SaaSCoType, GeneralCoType],
      },

      {
        id: "calculators",
        titles: {
          [SaaSCoType]: "Cash Runway Calculator",
          [GeneralCoType]: "Cash Runway Calculator",
        },
        type: "item",
        url: "/calculators/cash-runway",
        icon: <CalculatorIcon />,
        companyTypes: [SaaSCoType, GeneralCoType],
      },
    ],
  },
];
